<footer class="site-footer">
  <div class="site-footer-inner">
    <div class="site-footer-main">
      <div class="site-footer-brand">
        <img src="assets/img/logo.png" alt="Misericordia Borgo San Lorenzo">
      </div>

      <address class="site-footer-address">
        <strong>Misericordia Borgo San Lorenzo</strong>
        <span>Via Giotto, 34 — 50032</span>
        <span>Borgo San Lorenzo (FI)</span>
        <span>tel. 055 8494118</span>
        <span>P. IVA 01343220487</span>
      </address>

      <div class="site-footer-aside">
        <div class="site-footer-policies">
          <a routerLink="/privacy">Privacy Policy</a>
          <span class="site-footer-policies-sep" aria-hidden="true">·</span>
          <a routerLink="/cookie">Cookie Policy</a>
          <span class="site-footer-policies-sep" aria-hidden="true">·</span>
          <a routerLink="/condizioni-uso">Condizioni d’uso</a>
        </div>

        <div class="site-footer-findus">
          <span class="site-footer-findus-label">Trovaci su</span>
          <div class="site-footer-social">
            <button type="button" aria-label="Facebook"
              (click)="onClick('https://www.facebook.com/people/Misericordia-Borgo-San-Lorenzo/100063703517940/')">
              <i class="bi bi-facebook"></i>
            </button>
            <button type="button" aria-label="Sito della Misericordia" (click)="onClick('http://www.misericordia.net/')">
              <i class="bi bi-house-fill"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="site-footer-credit">
    Creato da <a href="https://wallnet.it/" target="_blank" rel="noopener noreferrer">Wallnet</a>
  </div>
</footer>
